import { useGetAllPointOfInterestTemplatesQuery } from '@/__generated__/graphql';
import { useGetStructureId } from './useGetStructureId';
import { useSelectedAssemblyTemplateId } from '@/components/Analysis/hooks/useSelectedAssemblyTemplateId';

const useFetchTemplatesByType = () => {
  const structureId = useGetStructureId();
  const selectedAssemblyTemplateId = useSelectedAssemblyTemplateId();

  const allTemplatesQueryResult = useGetAllPointOfInterestTemplatesQuery({
    variables: {
      structureId,
      assemblyTemplateId: selectedAssemblyTemplateId || '',
    },
    fetchPolicy: 'no-cache',
    skip: !structureId || !selectedAssemblyTemplateId,
  });

  return {
    data: allTemplatesQueryResult.data,
    loading: allTemplatesQueryResult.loading,
    error: allTemplatesQueryResult.error,
  };
};

export default useFetchTemplatesByType;
